import { useQuery, useQueryClient } from '@tanstack/react-query';
import { Box } from '@/components/Box/Box';
import { CardNew } from '@/components-new/CardNew/CardNew';
import { CardNewContent } from '@/components-new/CardNew/styles';
import { INVOICE_VAULT_QUERY_KEYS, loadPlatform } from '../../api/api';
import { PlatformConnectionCard } from './PlatformConnectionCard';
import { PlatformDefaultsForm } from './PlatformDefaultsForm';
import { PayerPreview } from './PayerPreview';
import { useUser } from '@/context/userContext';

export const IntegrationsTab = () => {
  const queryClient = useQueryClient();
  const { isMasterAdminRole } = useUser();

  const { data: platformResponse } = useQuery({ queryKey: INVOICE_VAULT_QUERY_KEYS.platform, queryFn: loadPlatform });
  const platform = platformResponse?.body ?? null;

  const invalidatePlatform = () => queryClient.invalidateQueries({ queryKey: INVOICE_VAULT_QUERY_KEYS.platform });

  return (
    <Box display='flex' flexDirection='column' gap='24px' marginTop='24px'>
      <Box display='grid' gridTemplateColumns='minmax(0, 1fr) 380px' gap='24px'>
        <CardNew>
          <CardNewContent>
            <PlatformConnectionCard platform={platform} canEdit={isMasterAdminRole} onChanged={invalidatePlatform} />
            {platform?.status === 'connected' && (
              <PlatformDefaultsForm platform={platform} canEdit={isMasterAdminRole} onChanged={invalidatePlatform} />
            )}
          </CardNewContent>
        </CardNew>
        <PayerPreview platform={platform} />
      </Box>
    </Box>
  );
};
